import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { FileField } from '../../../jbc-front/components/Form';
import Button from 'jbc-front/components/Button';

import { EMPLOYEE_BONUS_CSV_FORM } from 'src/constants/FormNames';
import { scrollToTop } from 'src/utils/Utils';

import { FormSubmitBtn } from 'src/buttons';
import {
  downloadTemplateCsv,
  importEmployeeBonusCsv,
  getEmployeeBonusItemErrors
} from 'src/reducers/employees/employeeBonus';
import { ENCODING_OPTIONS } from 'src/constants/Options';
import { UTF_8 } from 'src/constants/Generals';
import DownloadCsvEncodingRadioButton from 'src/components/DownloadCsvEncodingRadioButton';

import styles from './EmployeeBonusDownloadCsvForm.scss';
import { withTranslation } from 'react-i18next';

class EmployeeBonusCsvInsideForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors !== this.props.errors) {
      this.setState({
        errors: nextProps.errors
      });
      scrollToTop();
    }
  }

  componentDidUpdate() {
    this.props.updateState(this.state);
  }

  render() {
    const { handleSubmit, submitting, pristine, submit, downloadCsv } = this.props;

    return (
      <div className={styles.wrap}>
        <div className={styles.head}>{this.props.t('features.Employees.InsertBatchCsv.upload_process')}</div>
        <div className={styles.body}>
          <form onSubmit={handleSubmit}>
            <dl className={styles.label}>
              <dt className={styles.number}>1</dt>
              <dd className={styles.detail}>
                <p className={styles.text}>{this.props.t('features.Employees.InsertBatchCsv.select_the_output_format_and_use_the_downloaded_CSV_file')}</p>
                <DownloadCsvEncodingRadioButton
                  name={'encoding'}
                  label={null}
                  options={ENCODING_OPTIONS}
                  required={false}
                />
                <Button onClick={() => downloadCsv()} widthWide>
                  {this.props.t('features.EmployeeBonus.components.EmployeeBonusDownloadCsvForm.Download_bonus_data')}
                </Button>
              </dd>
            </dl>

            <dl className={styles.label}>
              <dt className={styles.number}>2</dt>
              <dd className={styles.detail}>
                {this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.change_provision_and_deduction_items_in_downloaded_CSV_file_as_needed_using_explanation_below_as_reference')}
                <p className={styles.caution}>
                  {this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.warning')}<br />
                  {this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.leave_automatically_calcuated_provision_and_deduction_items_such_as_insurance_premiums_blank')}<br />
                  {this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.items_with_input_value_will_not_be_automatically_calculated')}<br />
                  {this.props.t('features.EmployeeBonus.components.EmployeeBonusDownloadCsvForm.If_you_want_to_go_back_to_the_automatic_calculation_after_the_data_import_please_click_on_the_Go_back_to_before_manual_input_button_on_each_employees_bonus_edit_screen')}<br />
                </p>
              </dd>
            </dl>

            <dl className={styles.label}>
              <dt className={styles.number}>3</dt>
              <dd className={styles.detail}>
                <p className={styles.text}>{this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.select_completed_file_and_upload')}</p>
                <FileField label={this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.data_file_of_provision_and_deduction_items')} name="employee_bonus_csv" accepted="csv" required />
              </dd>
            </dl>

            <FormSubmitBtn text={this.props.t('features.EmployeePays.components.EmployeePayDownloadCsvForm.upload')} {...{ submitting, pristine, submit }} widthWide />
          </form>
        </div>
      </div>
    );
  }
}

const EmployeeBonusDownloadCsvForm = reduxForm({
  form: EMPLOYEE_BONUS_CSV_FORM
})(EmployeeBonusCsvInsideForm);
const mapStateToProp = state => ({
  initialValues: { encoding: UTF_8 },
  errors: getEmployeeBonusItemErrors(state)
});
const mapDispatchToProp = dispatch => ({
  onSubmit: data => dispatch(importEmployeeBonusCsv(data)),
  downloadCsv: () => dispatch(downloadTemplateCsv())
});

export default withTranslation('translation')(connect(mapStateToProp, mapDispatchToProp)(EmployeeBonusDownloadCsvForm));
